import { Injectable } from '@angular/core';
import { WIDGET } from 'ngx-mobile-app';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FORMSI } from '../interfaces/page-interface';

@Injectable({
  providedIn: 'root'
})
export class GridsterDropService {

  constructor() { }

  private selectedPageWidgets = new BehaviorSubject<{}[]>([]);

  selectedPageWidgets$: Observable<{}[]> = this.selectedPageWidgets.asObservable();

  private addedWidgetOrForm = new Subject<{widgetOrForm: WIDGET | FORMSI |  any, event: string}>();
  addedWidgetOrForm$ : Observable<{ widgetOrForm: WIDGET | FORMSI, event: string} > = this.addedWidgetOrForm.asObservable(); 
  setSelectedPageWidgets(widgets:{}[]) {
    this.selectedPageWidgets.next(widgets);
  }

  addWidgetToSelectedWidgets(widgetOrForm: WIDGET | FORMSI | any, event: string){
    this.addedWidgetOrForm.next({widgetOrForm, event});
  }

  getSelectedWidgets(){
    return this.selectedPageWidgets.value;
  }

}
